import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ToastContainer } from 'react-toastify'
import { getBorderRadius } from '../../../../utils/styleUtils'
// import { Drawer } from 'vaul'

/* CONSTANTS */
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'

export const ImageWrapper = styled.img``

export const MayaPopoverWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: ${props =>
    props.$popoverChatPosition === 'right' ? 'end' : 'start'};
  justify-content: center;
  right: ${props => (props.$popoverChatPosition === 'right' ? '25px' : 'auto')};
  left: ${props => (props.$popoverChatPosition === 'left' ? '25px' : 'auto')};
  bottom: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].POPVER_STICK_TO_BOTTOM
      ? '0px'
      : `${
          CLIENT_STYLINGS[props.theme.organizationSlug]
            .POPOVER_BOTTOM_DISTANCE ?? '25px'
        }`};

  z-index: 9999999999 !important;
  pointer-events: none;
  & > * {
    pointer-events: auto;
  }

  @media (max-width: ${size.mobileXL}) {
    right: 10px;
  }

  /* Target only Lucide icons (class starts with "lucide") so that other SVGs like
     company logos remain unaffected. */
  & svg.lucide,
  & svg.lucide * {
    fill: none !important;
    stroke: currentColor !important;
  }
`

export const PopoverChatIcon = styled.div`
  cursor: pointer;
  box-shadow: 0px 2px 6px 0px #0000001a;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  overflow: hidden;
  transition: transform 0.1s ease-out;
  background-color: ${({ theme }) =>
    CLIENT_STYLINGS[theme.organizationSlug].COLOR.PRIMARY};

  position: ${({ theme }) =>
    CLIENT_STYLINGS[theme.organizationSlug].POPOVER_CLOSE_WITH_AVATAR
      ? 'static'
      : 'absolute'};
  bottom: 0;
  right: 0;
  display: ${({ theme, $isOpen }) =>
    $isOpen &&
    !CLIENT_STYLINGS[theme.organizationSlug].POPOVER_CLOSE_WITH_AVATAR
      ? 'block'
      : 'block'};
  transform: ${({ theme, $isOpen }) => {
    if (!$isOpen) return 'rotate(0deg)'
    return CLIENT_STYLINGS[theme.organizationSlug].POPOVER_CLOSE_WITH_AVATAR
      ? 'rotate(45deg)'
      : 'scale(0.95)'
  }};
`

export const PopoverChatCloseIcon = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
`

export const PopoverWidgetChatWrapper = styled.div`
  width: 100px;
  height: 300px;
`

export const ChatSectionWrapper = styled.div`
  width: 100%;
  position: relative;
  transform-origin: bottom right;

  transition:
    opacity 0.15s ease-out,
    transform 0.15s ease-out,
    display 0.15s allow-discrete;
  transition-behavior: allow-discrete;

  /* Show/hide based on $isOpen prop */
  display: ${props => (props.$isOpen ? 'block' : 'none')};
  opacity: ${props => (props.$isOpen ? '1' : '0')};
  transform: ${props => (props.$isOpen ? 'scale(1)' : 'scale(0.95)')};

  height: ${props => {
    const baseHeight =
      CLIENT_STYLINGS[props.theme.organizationSlug].POPOVER_DESKTOP_HEIGHT ||
      '500px'
    const extraHeight = props.$enableAiQuickReplies ? 200 : 0
    return `calc(${baseHeight} + ${extraHeight}px)`
  }};
  width: 350px;
  max-height: 75vh;
  z-index: 1;
  box-shadow: 0px 2px 6px 0px #0000001a;
  border-radius: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].POPVER_STICK_TO_BOTTOM
      ? '20px 20px 0 0'
      : getBorderRadius(props, 'xl')};
  overflow: hidden;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};

  @media (max-width: ${size.mobileXL}) {
    height: ${props =>
      (CLIENT_STYLINGS[props.theme.organizationSlug].POPOVER_MOBILE_HEIGHT ||
        '475px') + (props.$enableAiQuickReplies ? ' + 150px' : '')};
    width: calc(100vw - 20px);
    max-height: 85vh;
  }

  /* Starting style for smooth entry animation when transitioning from display: none */
  @starting-style {
    opacity: 0;
    transform: scale(0.95);
  }
`

export const ChatSectionScrollable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props =>
    props.$isMobile && props.$isTextareaFocused ? 'flex-end' : 'flex-start'};
  overflow-y: scroll;
  padding: 16px 8px 40px 8px;
  height: calc(100% - 50px);
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  &::-webkit-scrollbar {
    display: none;
  }
`

export const MayaInputContainerWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;

  @media (max-width: ${size.laptop}) {
    bottom: 0px;
  }
`

export const MayaInputContainer = styled.div`
  margin: auto;
  width: 100%;
  position: relative;
`

export const MayaMessageInputWrapper = styled.div`
  position: relative;
  padding: 8px;
  display: flex;
  align-items: end;
  gap: 8px;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  border-top: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
`

export const MayaMessageInput = styled.textarea`
  width: 100%;
  border: 0px;
  min-height: 40px;
  max-height: 200px;
  display: block;
  padding: 10px 12px;
  line-height: 20px;

  border-radius: ${props => getBorderRadius(props, 'lg')};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  resize: none;
  font-size: 14px !important;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED};
  overflow-y: hidden;

  @media (max-width: ${size.mobileXL}) {
    font-size: 16px !important;
  }

  &:focus {
    outline: none !important;
  }
  &:hover {
    cursor: text;
  }
`

export const MayaInputBox = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
`

export const MayaMessageInputSubmitButton = styled.button`
  background: none;
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  flex-shrink: 0;
  overflow: hidden;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${props => (props.$disabled ? 'none' : 'auto')};
  opacity: ${props => (props.$disabled ? 0.75 : 1)};
  padding: 0px;
  transition: opacity 0.1s;

  &:hover {
    opacity: 0.75;
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const MayaQuickRepliesConatiner = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding-right: 0px;
  justify-content: flex-end;
  padding-left: 20px;
  margin-bottom: 22px;
`

export const MayaQuickRepliesBullet = styled.div`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 5px 10px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  margin: 0 5px 10px 0;
  text-align: left;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
    cursor: pointer;
  }
`

// Create the animation
const colorPulse = keyframes`
  0%, 100% {
    background-position: 0% center;
    opacity: 0.8;
  }
  50% {
    background-position: 100% center;
    opacity: 1;
  }
`

export const ReasoningText = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(
    90deg,
    #555555,
    #777777,
    #999999,
    #bbbbbb,
    #999999,
    #777777,
    #555555
  );
  background-size: 200% auto;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  animation: ${colorPulse} 3s ease-in-out infinite;
  display: inline-block;
`

export const TypingContainer = styled.div`
  width: 50em;
  height: 2em;
  position: relative;
  padding: 10px;
  margin-left: 5px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  border-radius: ${props => getBorderRadius(props, 'xl')};
`

export const RegenerateResponse = styled.div`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 12px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
  padding: 6px 12px;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  align-self: center;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.1s;

  &:hover {
    background-color: ${props =>
      `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY}80`};
  }
  &:active {
    border: 2px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
  }
`

export const UserInputContainer = styled.div`
  padding: 20px;
  background: rgba(0, 113, 138, 0.15);
  border-radius: ${props => getBorderRadius(props, 'xl')};
  display: flex;
  flex-direction: column;
  width: ${props => (props.isMayaFullScreen ? '35%' : '100%')};

  @media (max-width: ${size.laptop}) {
    width: 100%;
  }
`

export const ChatSectionCtaWrapper = styled.div`
  margin-bottom: 10px;
  width: 100%;
`

export const ChatSectionCtaActionsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-self: center;
  padding: 0px 8px;
  gap: 6px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: -20px;
    left: 0;
    right: 0;
    bottom: -10px;
    background: linear-gradient(
      to bottom,
      transparent,
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND}
    );
    pointer-events: none;
    display: ${props => (props.$hasButtons ? 'block' : 'none')};
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`
export const MessageContentContainer = styled.div`
  display: flex;
  align-self: ${props => props?.sender && 'flex-end'};
`

export const FeedbackContainer = styled.div`
  margin-top: 4px;
  display: flex;
  align-self: flex-start;
  margin-bottom: ${props => (props?.removeMarginBottom ? '0px' : '22px')};
`

export const LeaveFeedbackText = styled.span`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  font-size: 12px;
`

export const FeedbackIconWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover .tooltip-text {
    visibility: visible;
  }
`

export const FeedbackIconTooltipText = styled.span`
  visibility: hidden;
  width: max-content;
  left: calc(100% + 6px);
  top: 2px;
  box-shadow: 0px 1px 2px 0px #0000001a;
  padding: 4px 10px;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  text-align: center;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  font-size: 12px;

  position: absolute;
  z-index: 1;
`

export const FeedbackIcon = styled.svg`
  color: ${props =>
    `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND}BF`};
  cursor: ${props => (props?.saved ? 'default' : 'pointer')};
  height: 28px;
  width: 28px;
  padding: 4px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  transition: background-color 0.1s;
  fill: ${props =>
    `${CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND}BF`};
  &:hover {
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY};
  }
`

export const MessageAvatarContainer = styled.div`
  border-radius: ${props => getBorderRadius(props, 'sm')};
  overflow: hidden;
  height: 34px;
`

export const DisclaimerMessage = styled.span`
  font-style: italic;
  font-size: 11px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  color: ${props =>
    props?.hasHallucination
      ? 'red'
      : props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  background-color: ${props =>
    props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ASSISTANT_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};

  a {
    color: #4183c4;
    text-decoration: none;
    background-color: transparent;
    font-size: 11px !important;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  }
`

export const HallucinationDisclaimerMessage = styled.span`
  font-style: italic;
  font-size: 14px;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  color: ${props =>
    props?.hasHallucination
      ? 'red'
      : props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
          .ASSISTANT_FOREGROUND};
  background-color: ${props =>
    props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ASSISTANT_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
`

export const MessageTextContainer = styled.div`
  text-align: left;
  padding: 6px 12px;
  margin: ${props => (props?.sender ? '0 0px 0 30px' : '0 30px 0 0px')};
  border-radius: ${props => getBorderRadius(props, 'lg')};

  color: ${props =>
    props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
          .ASSISTANT_FOREGROUND} !important;

  background-color: ${props =>
    props?.sender
      ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER
      : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.ASSISTANT};
  font-size: 1rem;
  line-height: 1.1rem;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  white-space: pre-line;
  min-width: 50px;
  word-wrap: break-word;

  overflow-x: auto;

  table {
    border-collapse: collapse; /* Ensures borders are not doubled */
    width: 100%; /* Optional: Makes the table full width */
  }

  tr,
  th {
    border-bottom: 1px solid
      ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER}; /* Adds a border between rows */
  }

  th,
  td {
    padding: 8px; /* Adds spacing inside cells */
    text-align: left; /* Aligns text to the left */
  }

  /* Optional: Remove border from the last row */
  tr:last-child {
    border-bottom: none;
  }

  th {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND};
  }

  td {
    font-size: 14px;
    line-height: 22px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  }

  li p + ul,
  li p + ol {
    padding-top: 0 !important;
  }

  ol {
    padding-top: 10px;
    list-style-type: decimal;
    padding-inline-start: 20px;
    margin-block-start: 0px;
    margin-block-end: 0px;

    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    white-space: normal;
  }

  ul {
    padding-top: 10px;
    padding-inline-start: 20px;
    margin-block-start: 0px;
    margin-block-end: 0px;

    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    white-space: normal;
  }

  li {
    margin-block-start: 0px;
    margin-block-end: 0px;

    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    white-space: normal;
    p {
      padding-bottom: 5px;
      display: block;
    }

    &::marker {
      font-size: 12px;
    }
  }

  li:not(:last-child) {
    padding-bottom: 5px;
  }

  li {
    li:not(:last-child) {
      padding-bottom: 5px;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  hr {
    display: none;
  }

  p {
    margin-block-start: 0px;
    margin-block-end: 0px;
    display: block;
    margin: 0px;
    padding: 0px;

    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  }

  a {
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : '#4183c4'} !important;
    text-decoration: none;
    background-color: transparent;
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};

    font-weight: ${props => (props?.sender ? 'bold' : 'normal')};
    text-decoration: ${props => (props?.sender ? 'underline' : 'none')};
  }

  strong {
    font-size: 14px;
    font-family: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
    font-weight: bold;
  }

  /* Explicitly set colour for all nested text elements, as in the previous branch */
  p,
  li,
  ul,
  ol,
  td,
  th,
  strong {
    color: ${props =>
      props?.sender
        ? CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.USER_FOREGROUND
        : CLIENT_STYLINGS[props.theme.organizationSlug].COLOR
            .ASSISTANT_FOREGROUND} !important;
  }
`

export const PopoverChatIconsWrapper = styled.div`
  width: 100%;
  background: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  display: flex;
  justify-content: space-between;
  padding: 8px;
  align-items: center;
  height: 50px;
`

export const PopoverChatIconWrapper = styled.a`
  cursor: pointer;
  transition: background-color 0.1s;
  background: transparent;
  border: none;
  padding: 4px;
  height: 28px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};

  &:hover {
    background-color: ${props =>
      `${
        CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND
      }30`};
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`

export const PopoverChatIconsLeftSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  height: 100%;
  gap: 8px;
`

export const PopoverChatIconsRightSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export const PoweredByMayaWrapper = styled.div`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  padding: 0px 4px;
  text-align: right;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
`
export const PoweredByMayaText = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
`

export const PoweredByMayaLink = styled.a`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  line-height: 12px;
  font-size: 10px;
  font-weight: 600;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
`

export const BotNameWrapper = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 20px;
  font-weight: 600;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  line-height: 20px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const StatusDot = styled.div`
  width: 6px;
  height: 6px;
  background-color: #1ff45a;
  border-radius: 50%;
  margin-top: 2px;
`

// export const DrawerOverlay = styled(Drawer.Overlay)`
//   position: fixed;
//   inset: 0;
//   background-color: rgba(0, 0, 0, 0.4);
// `

// export const DrawerContent = styled(Drawer.Content)`
//   position: fixed;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   margin-top: 6rem;
//   height: 80vh;
//   background-color: white;
//   border-top-left-radius: ${props => getBorderRadius(props, 'xl')};
//   border-top-right-radius: ${props => getBorderRadius(props, 'xl')};
//   outline: none;
//   overflow: hidden;
// `

// export const DrawerHandle = styled(Drawer.Handle)`
//   position: absolute;
//   top: 5px;
//   left: 0;
//   right: 0;
//   width: 48px;
//   height: 3px;
//   z-index: 1;
//   background-color: ${props =>
//     CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
//   border-radius: ${props => getBorderRadius(props, 'full')};
//   opacity: 0.5;
// `

export const NotificationContainer = styled.div`
  padding: 8px 20px;
  border-radius: ${props => getBorderRadius(props, 'lg')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 15px;
  text-align: right;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  line-height: 1.4;
  box-shadow: 0px 2px 6px 0px #0000001a;
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  animation: fadeIn 0.3s ease-in-out;
  width: max-content;
  max-width: 70vw;
  margin-bottom: 10px;
  position: absolute;
  bottom: ${props => props.$bottom};
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: ${size.mobileXL}) {
    font-size: 12px;
    padding: 4px 8px;
  }
`

export const NotificationDismissButton = styled.div`
  position: absolute;
  padding: 4px 5px;
  top: 0px;
  right: 0px;
  cursor: pointer;
  line-height: 0;
  opacity: 1;
  transition: opacity 0.15s;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};

  &:hover {
    opacity: 0.2;
  }
`

export const CustomPopoverAvatarWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: flex-end;
  width: ${props => props.$width} !important;

  img {
    cursor: pointer;
    transition: all 0.15s allow-discrete;
    opacity: ${props => (props.$isOpen ? 0 : 1)};
    transform: ${props => (props.$isOpen ? 'scale(0.95)' : 'scale(1)')};
    display: ${props => (props.$isOpen ? 'none' : 'block')};
    filter: drop-shadow(0px 2px 6px #0000001a);
  }
`
